import cx from 'classnames';
import { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { SelectOption } from '../../commonTypes';
import styles from './style.module.scss';

interface GroupedOption {
  label: string;
  options: SelectOption[];
}

interface StateProps {
  name: string;
  id: string;
  options: (SelectOption | GroupedOption)[];
  onChange?: (data: any) => void;
  type?: string;
  placeHolder?: string;
  width?: string;
  defaultValue?: string | [];
  className?: string;
  required?: boolean;
  errrorMessage?: string;
  multiple?: boolean;
}

const isGroupedOption = (opt: SelectOption | GroupedOption): opt is GroupedOption => {
  return (opt as GroupedOption).options !== undefined;
};

const SelectBox: FC<StateProps> = ({
  name,
  id,
  width,
  options,
  onChange,
  defaultValue,
  className,
  required,
  errrorMessage,
  multiple = false
}) => {
  return (
    <>
      <Form.Select
        value={defaultValue}
        onChange={onChange}
        className={cx(styles.selectBox, className)}
        name={name}
        id={id}
        style={{ width }}
        required={required}
        multiple={multiple}
      >
        <option value="" disabled hidden>
          Select
        </option>

        {options.map((option, index) => {
          if (isGroupedOption(option)) {
            // Render group
            return (
              <optgroup key={index} label={option.label}>
                {option.options.map((subOption, subIndex) => (
                  <option key={`${index}-${subIndex}`} value={subOption.value}>
                    {subOption.label}
                  </option>
                ))}
              </optgroup>
            );
          }
          // Render single option
          return (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </Form.Select>
      <Form.Control.Feedback type="invalid">
        {errrorMessage}
      </Form.Control.Feedback>
    </>
  );
};

export default SelectBox;
